import {
  Typography,
  Skeleton,
  Row,
  Col,
  Form,
  DatePicker,
  Card,
  Statistic,
  Button,
  Popconfirm,
  Modal,
  Input,
} from "antd";
import cookie from "react-cookies";

import { useEffect, useState } from "react";
import BonLivraisonModal from "../Vente/BL/BonLivraisonModal";
import {
  toGetTotalHT,
  toGetListDelivery,
  toDebloqueBonus,
  toBloqueBonus,
  toAddBlocageManuel,
  toUpdateBlocageManuel,
  toDeleteBlocageManuel,
} from "./APIs";
import moment from "moment";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { toGetUsers } from "../Compte/Api";
import { errorMsg, successMsg } from "../../Utils/Utils";
const Objectif = ({ AppStore, ...props }) => {
  const [data, setData] = useState([]);
  const [date, setDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [blToInspect, setBlToInspect] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [users, setUsers] = useState([]);
  const [blockModal, setBlockModal] = useState(null);
  const [blockReason, setBlockReason] = useState("");
  const [blockEndAt, setBlockEndAt] = useState(null);
  const [blockSaving, setBlockSaving] = useState(false);

  useEffect(() => {
    AppStore.setFirst(2);
    AppStore.setSecond(12);
    toGetUsers().then((users) => {
      setUsers(users.filter((x) => x.role === "chauffeur" && x.active));
      getData(
        new Date(),
        users.filter((x) => x.role === "chauffeur" && x.active),
      );
    });
  }, []);

  const toConvertDateTime = (date) => {
    const offset = getOffset(date);
    return moment(date).subtract(0, "h").format("LL H:mm");
  };

  const getOffset = (date) => {
    const zone = moment(date).zone();
    const offset = zone + 60;
    return offset;
  };

  const toVerifyDate = (cnxDate, entityId) => {
    const offset = getOffset(date) + 1;

    const cnx = moment(cnxDate);
    const selectedDate = moment(cnx.format("YYYY-MM-D")).set({
      hour: 9,
      minute: 0,
      second: 59,
    });

    if (cnx.isBefore(selectedDate)) {
      return true;
    }
    return false;
  };

  const toVerifyDateDriver = (cnxDate) => {
    const offset = getOffset(date) + 1;

    const cnx = moment(cnxDate);

    const selectedDate = moment(cnx.format("YYYY-MM-D")).set({
      hour: 9,
      minute: 30,
      second: 59,
    });

    if (cnx.isBefore(selectedDate)) {
      return true;
    }
    return false;
  };

  const toGetCoefficient = (cnxDate) => {
    const cnx = moment(cnxDate);
    // var selectedDate = moment(cnx.format("YYYY-MM-D")).set({
    //   hour: 8,
    //   minute: 0,
    //   second: 59,
    // });

    // if (cnx.isBefore(selectedDate)) {
    //   return 30;
    // }

    var selectedDate = moment(cnx.format("YYYY-MM-D")).set({
      hour: 8,
      minute: 15,
      second: 59,
    });

    if (cnx.isBefore(selectedDate)) {
      return 30;
    }

    selectedDate = moment(cnx.format("YYYY-MM-D")).set({
      hour: 8,
      minute: 30,
      second: 59,
    });

    if (cnx.isBefore(selectedDate)) {
      return 10;
    }
    // selectedDate = moment(cnx.format("YYYY-MM-D")).set({
    //   hour: 9,
    //   minute: 0,
    //   second: 59,
    // });

    // if (cnx.isBefore(selectedDate)) {
    //   return 0;
    // }

    return 0;

    // return -100;
  };

  const getData = (date, l__users) => {
    setLoading(true);
    setData([]);
    setDate(date);
    toGetTotalHT(date).then((res) => {
      setData(res);
      setLoading(false);
    });

    toGetListDelivery(moment(date).format("YYYY-MM-DD")).then(
      ({ list, caisses }) => {
        const res = [...list];
        const unique = [...new Set(res.map((item) => item.driver))];

        var drivers = [];
        l__users.forEach((el) => {
          drivers.push({
            driver: el.username,
            date: el.lastLogin,
            nb: 0,
            caisses: 0,
          });
        });
        unique.forEach((el) => {
          const count = res.filter((obj) => obj.driver == el).length;
          if (drivers.findIndex((x) => x.driver == el) != -1) {
            drivers[drivers.findIndex((x) => x.driver == el)].nb = count;
          }
        });
        drivers.forEach((element, i) => {
          const count = caisses.filter((obj) => element.driver === obj.recived)
            .length;
          if (drivers.findIndex((x) => x.driver === element.driver) != -1) {
            drivers[
              drivers.findIndex((x) => x.driver === element.driver)
            ].caisses = count;
          }
        });
        console.log({ drivers });
        setDrivers(drivers);
      },
    );
  };

  const refreshData = () => {
    getData(
      date,
      users.filter((x) => x.role === "chauffeur" && x.active),
    );
  };

  const toGetBlocageActif = (element) => {
    if (!element.blockedItems) return null;
    return element.blockedItems.find((el) => el.type === 3);
  };

  const toOuvrirBlocage = (element, blocage) => {
    setBlockModal({
      mode: blocage ? "edit" : "create",
      element: element,
      blocage: blocage,
    });
    setBlockReason(blocage ? blocage.message : "");
    setBlockEndAt(blocage ? moment(blocage.endAt) : null);
  };

  const toEnregistrerBlocage = () => {
    const reason = blockReason.trim();
    if (reason === "") {
      errorMsg("Le motif est obligatoire");
      return;
    }
    if (null == blockEndAt) {
      errorMsg("La date de fin est obligatoire");
      return;
    }
    const endAt = moment(blockEndAt).format("YYYY-MM-DD HH:mm:ss");
    if (moment(endAt).isBefore(moment())) {
      errorMsg("La date de fin doit être dans le futur");
      return;
    }
    setBlockSaving(true);
    const request =
      blockModal.mode === "edit"
        ? toUpdateBlocageManuel(blockModal.blocage.id, reason, endAt)
        : toAddBlocageManuel(blockModal.element.id, reason, endAt);
    request
      .then(() => {
        setBlockSaving(false);
        setBlockModal(null);
        successMsg("Le blocage a été enregistré");
        refreshData();
      })
      .catch((e) => {
        setBlockSaving(false);
        errorMsg(
          e.response && e.response.data && e.response.data.errors
            ? e.response.data.errors
            : "Une erreur est survenue",
        );
      });
  };

  const toSupprimerBlocage = (blocage) => {
    toDeleteBlocageManuel(blocage.id)
      .then(() => {
        successMsg("Le blocage a été supprimé");
        refreshData();
      })
      .catch((e) => {
        errorMsg(
          e.response && e.response.data && e.response.data.errors
            ? e.response.data.errors
            : "Une erreur est survenue",
        );
      });
  };

  const getBonus = (element) => {
    var total = element.bonus;
    var bonus = 0;
    if (total > 8500) {
      bonus = ((total - 8500) * 1) / 100 + 85;
    } else if (total > 5500) {
      bonus = ((total - 5500) * 1) / 100 + 45;
    } else if (total > 3500) {
      bonus = ((total - 3500) * 1) / 100 + 25;
    } else if (total > 2000) {
      bonus = ((total - 2000) * 1) / 100 + 10;
    }
    var l__bonus = bonus > 145 ? 145 : bonus;
    var coefficient = toGetCoefficient(element.date);

    l__bonus = (l__bonus * (100 + coefficient)) / 100;

    //var retard = toGetRetard(element.retard);
    //l__bonus = (l__bonus * (100 + retard)) / 100;

    return l__bonus.toFixed(2);
  };

  const getNewBonus2026 = (element) => {
    var total = element.bonus;
    var bonus = 0;
    if (total > 9000) {
      bonus = ((total - 9000) * 1.2) / 100 + 85 * 1.2;
    } else if (total > 5700) {
      bonus = ((total - 5700) * 1.2) / 100 + 45 * 1.2;
    } else if (total > 3200) {
      bonus = ((total - 3200) * 1.15) / 100 + 30;
    } else if (total > 2500) {
      bonus = ((total - 2500) * 1.1) / 100 + 10 * 1.1;
    }
    var l__bonus = bonus > 145 ? 145 : bonus;
    var coefficient = toGetCoefficient(element.date);

    l__bonus = (l__bonus * (100 + coefficient)) / 100;
    //var retard = toGetRetard(element.retard);
    //l__bonus = (l__bonus * (100 + retard)) / 100;

    return l__bonus.toFixed(2);
  };

  const getNewBonus = (element) => {
    var total = element.bonus;

    var bonus = 0;
    // if (total > 9775) {
    //   bonus = ((total - 9775) * 1) / 100 + 60;
    // } else if (total > 6325) {
    //   bonus = ((total - 6325) * 1) / 100 + 40;
    // } else if (total > 4025) {
    //   bonus = ((total - 4025) * 1) / 100 + 23;
    // } else

    if (total > 2300) {
      bonus = ((total - 2300) * 1) / 100 + 10;
    }
    var l__bonus = bonus > 145 ? 145 : bonus;

    var coefficient = toGetCoefficient(element.date);
    l__bonus = (l__bonus * (100 + coefficient)) / 100;
    var retard = toGetRetard(element.retard);
    l__bonus = (l__bonus * (100 + retard)) / 100;

    return l__bonus.toFixed(2);
  };

  const toGetRetard = (retard) => {
    if (retard > 11) return -50;
    if (retard > 8) return -40;
    if (retard > 5) return -30;
    if (retard > 2) return -20;
    return 0;
  };

  return (
    <>
      <Row className="auto--custom-header">
        <Col span="8">
          <Typography.Title level={3}>OBJECTIFS</Typography.Title>
        </Col>
        <Col span="4">
          <Form.Item label="Date">
            <DatePicker
              style={{ width: "100%" }}
              onChange={(e, date) => {
                getData(date, users);
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row style={{ marginTop: "1vh" }}>
        <Col span="21">
          <div className="table-wrapper auto--overflow">
            <table className="ant-table" style={{ width: "100%" }}>
              <thead className="ant-table-thead">
                <tr>
                  <th className="ant-table-cell">Utilisateur </th>
                  <th className="ant-table-cell">Total Vente HT</th>
                  <th className="ant-table-cell">Date dernière connexion</th>
                  <th className="ant-table-cell">BL(s) Non payé</th>
                  <th className="ant-table-cell">Bonus </th>
                  <th className="ant-table-cell">Bonus Bloqué</th>
                  <th className="ant-table-cell">Actions</th>
                </tr>
              </thead>
              <Skeleton active loading={loading} />
              <tbody className="ant-table-tbody">
                {data.map((element) => {
                  const blocageActif = toGetBlocageActif(element);
                  return (
                    <tr
                      className={
                        element.bonus > 3500 && element.bls.length > 0
                          ? "auto--objectif-pass"
                          : element.bonus > 3500 &&
                            element.bls.length == 0 &&
                            "auto--objectif-done"
                      }
                    >
                      <td className="ant-table-cell">{element.username}</td>
                      <td className="ant-table-cell">{element.bonus}</td>
                      <td className="ant-table-cell">
                        {null != element.date
                          ? toConvertDateTime(element.date)
                          : "non connecté"}
                      </td>
                      <td className="ant-table-cell">
                        {element.bls.map((e) => (
                          <Typography.Link onClick={() => setBlToInspect(e.id)}>
                            {e.ref + "  **  "}
                          </Typography.Link>
                        ))}
                      </td>
                      <td className="ant-table-cell">
                        {toVerifyDate(element.date, element.entityId)
                          ? element.blocked
                            ? "Le bonus a été bloqué"
                            : getNewBonus2026(element)
                          : "Vous avez ouvert aprés  9h00"}
                      </td>
                      <td className="ant-table-cell">
                        {
                          <ul>
                            {element.blockedItems.map((el) => (
                              <div style={{ marginTop: "5px" }}>
                                <li>
                                  {el.type === 3 ? (
                                    <>
                                      <b>Blocage manuel :</b> {el.message}
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          color: "#8c8c8c",
                                        }}
                                      >
                                        Depuis le{" "}
                                        {moment(el.startAt).format(
                                          "YYYY-MM-DD HH:mm",
                                        )}{" "}
                                        — jusqu'au{" "}
                                        {moment(el.endAt).format(
                                          "YYYY-MM-DD HH:mm",
                                        )}
                                        {el.blockedBy
                                          ? " — bloqué par " + el.blockedBy
                                          : ""}
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {el.message}{" "}
                                      {el.blocked == -1 &&
                                        cookie.load("role") == "Super Admin" && (
                                          <Button
                                            type="primary"
                                            onClick={() =>
                                              toDebloqueBonus(
                                                element.id,
                                                el.type,
                                                date,
                                              ).then((res) => {
                                                getData(
                                                  date,
                                                  users.filter(
                                                    (x) =>
                                                      x.role === "chauffeur" &&
                                                      x.active,
                                                  ),
                                                );
                                              })
                                            }
                                          >
                                            Débloquer
                                          </Button>
                                        )}
                                      {el.blocked !== -1 && (
                                        <>
                                          -- validé par:
                                          <span className="auto--color-success auto--pointer">
                                            <Popconfirm
                                              title={`Voulez vous vraiment bloquer cet enregistrement?`}
                                              onConfirm={() =>
                                                toBloqueBonus(el.id).then(
                                                  (res) => {
                                                    getData(
                                                      date,
                                                      users.filter(
                                                        (x) =>
                                                          x.role ===
                                                            "chauffeur" &&
                                                          x.active,
                                                      ),
                                                    );
                                                  },
                                                )
                                              }
                                            >
                                              {el.validatedBy}
                                            </Popconfirm>
                                          </span>
                                        </>
                                      )}
                                    </>
                                  )}
                                </li>
                                {el.type === 2 && (
                                  <ul>
                                    {el.list.map((e) => (
                                      <li className="">{e}</li>
                                    ))}
                                  </ul>
                                )}
                              </div>
                            ))}
                          </ul>
                        }
                      </td>
                      <td className="ant-table-cell">
                        {cookie.load("role") == "Super Admin" &&
                          element.role === "vendeur" &&
                          (blocageActif ? (
                            <>
                              <Button
                                type="primary"
                                onClick={() =>
                                  toOuvrirBlocage(element, blocageActif)
                                }
                              >
                                Modifier
                              </Button>
                              <Popconfirm
                                title={`Voulez vous vraiment supprimer ce blocage?`}
                                onConfirm={() => toSupprimerBlocage(blocageActif)}
                              >
                                <Button style={{ marginTop: "5px" }} danger>
                                  Supprimer
                                </Button>
                              </Popconfirm>
                            </>
                          ) : (
                            <Button
                              type="primary"
                              onClick={() => toOuvrirBlocage(element, null)}
                            >
                              Bloquer
                            </Button>
                          ))}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Col>
        <Col span="3"></Col>
      </Row>
      {data.length > 0 && (
        <Row>
          <Col span="24">
            <div style={{ height: 300 }}>
              <ResponsiveContainer>
                <BarChart
                  height={400}
                  data={data}
                  style={{ marginTop: "50px", marginBottom: "2vh" }}
                >
                  <XAxis dataKey="username" fontFamily="Proxima Nova"></XAxis>
                  <Tooltip cursor={{ fill: "transparent" }} />

                  <Bar
                    radius={[2, 2, 0, 0]}
                    dataKey="total"
                    barSize={200}
                    stackId="a"
                    fill="#846eb1"
                    fontFamily="Proxima Nova"
                  >
                    {data.map((entry, index) => (
                      <Cell></Cell>
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </Col>
        </Row>
      )}
      <div style={{ margin: "20px", textAlign: "center" }}>
        <b style={{ fontSize: "20px" }}>Chauffeurs</b>
      </div>
      <Row style={{ marginTop: "20px" }} justify="center">
        {drivers
          .sort((a, b) => b.nb - a.nb)
          .map((el) => (
            <Col span={4}>
              <Card bordered type="inner" title={el.driver}>
                <Statistic
                  title={"Livraison(s):"}
                  value={el.nb}
                  valueStyle={{ color: "darkorange" }}
                />

                <Statistic
                  title={"Réglement(s) apporté(s):"}
                  valueStyle={{ color: "darkorange" }}
                  value={el.caisses}
                />
                <Statistic
                  title={"Total:"}
                  value={
                    toVerifyDateDriver(el.date) ? el.nb + el.caisses * 2 : "-"
                  }
                  valueStyle={{ color: "#1b9e4d" }}
                />
              </Card>
            </Col>
          ))}
      </Row>
      <BonLivraisonModal
        entete={true}
        id={blToInspect}
        onClose={() => setBlToInspect(null)}
      />
      <Modal
        visible={null != blockModal}
        title={
          null != blockModal
            ? blockModal.mode === "edit"
              ? "Modifier le blocage de " + blockModal.element.username
              : "Bloquer le bonus de " + blockModal.element.username
            : ""
        }
        okText={
          null != blockModal && blockModal.mode === "edit"
            ? "Enregistrer"
            : "Bloquer"
        }
        confirmLoading={blockSaving}
        onOk={() => toEnregistrerBlocage()}
        onCancel={() => setBlockModal(null)}
      >
        <Form layout="vertical">
          <Form.Item label="Motif" required>
            <Input.TextArea
              rows={3}
              value={blockReason}
              placeholder="Raison du blocage"
              onChange={(e) => setBlockReason(e.target.value)}
            />
          </Form.Item>
          <Form.Item label="Date et heure de fin" required>
            <DatePicker
              showTime
              style={{ width: "100%" }}
              value={blockEndAt}
              placeholder="Date et heure de fin du blocage"
              onChange={(value) => setBlockEndAt(value)}
              disabledDate={(current) =>
                current && current < moment().startOf("day")
              }
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default Objectif;
